module.exports = __webpack_public_path__ + "img/block5.550bceb6.svg";